const DocumentClasses = {
  Document: "t-doc",
  Header: "t-doc__header",
  Sidebar: "t-doc__sidebar",
  TableOfContents: "t-doc__toc",
  Search: "t-doc__search"
};
export {
  DocumentClasses
};
//# sourceMappingURL=document-classes.js.map
